import { ButtonBase } from '@mui/material';
import { t } from 'i18next';
import { lazy, Suspense } from 'react';
import { borderRadius } from '../../../theme/borderRadius';
import { colors } from '../../../theme/colors';
import {
  flexCenteredContentContainerStyles,
  flexCenteredParentContainerStyles,
} from '../../../theme/containers';
import spacing, { spacingInUnits } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import LoadingScreen from '../../LoadingIndicators/LoadingScreen';
import { useAddNewLocationModalContext } from './AddNewLocationModalProvider';
import ChooseLocationByDevice from './ChooseLocationByDevice';
const ChooseGeneralLocation = lazy(() => import('./ChooseGeneralLocation'));
const OpenChooseOtherLocation = () => {
  const { isAddOtherLocationChosen, setIsAddOtherLocationChosen } =
    useAddNewLocationModalContext();

  if (isAddOtherLocationChosen) {
    return null;
  }
  return (
    <div
      style={{
        marginTop: spacingInUnits.xl * 2,
      }}
    >
      <ButtonBase
        onClick={() => setIsAddOtherLocationChosen(true)}
        style={{
          color: colors.textPrimary,
          fontSize: fontSize.md,
          paddingRight: spacing.medium,
          paddingLeft: spacing.medium,
          paddingTop: spacing.smallMedium,
          paddingBottom: spacing.smallMedium,
          borderRadius: borderRadius.medium,
        }}
      >
        {t('location.chooseOtherLocation')}
      </ButtonBase>
    </div>
  );
};

const ChooseLocationContent = ({
  handleModalClose,
}: {
  handleModalClose: () => void;
}) => {
  const { isAddOtherLocationChosen } = useAddNewLocationModalContext();

  if (isAddOtherLocationChosen) {
    return (
      <Suspense fallback={<LoadingScreen absolute={true} />}>
        <ChooseGeneralLocation onClose={handleModalClose} />
      </Suspense>
    );
  }
  return <ChooseLocationByDevice onClose={handleModalClose} />;
};
const AddNewLocationModalContent = ({
  handleModalClose,
}: {
  handleModalClose: () => void;
}) => {
  return (
    <div
      style={{
        ...flexCenteredParentContainerStyles,
        padding: spacing.medium,
        backgroundColor: colors.backgroundMedium,
      }}
    >
      <div style={flexCenteredContentContainerStyles}>
        <ChooseLocationContent handleModalClose={handleModalClose} />

        <OpenChooseOtherLocation />
      </div>
    </div>
  );
};

export default AddNewLocationModalContent;
